<template>
  <div
    :class="{
      'flex flex-col gap-6 lg:flex-row': true,
    }"
  >
    <FlipCard
      v-for="(card, index) in cards"
      :key="index"
      v-bind="card"
    />
  </div>
</template>
<script setup lang="ts">
import FlipCard from './FlipCard.vue';
import type { FlipCards } from '~/sanity/types';

defineProps<FlipCards>();
</script>

<style lang="scss" scoped></style>
